export interface TestimonialType {
  id: number;
  name: string;
  position?: string;
  company?: string;
  image: string;
  rating: number;
  testimonial: string;
  isCorporate?: boolean; // true for corporate testimonials, false/undefined for regular bookings
}

export const testimonials: TestimonialType[] = [
  // {
  //   id: 1,
  //   name: "Jonathan Stevens",
  //   position: "CFO",
  //   company: "Global Innovations Inc.",
  //   image: "/images/testimonials/jonathan-stevens.jpg",
  //   rating: 5,
  //   testimonial: "The United Travel has been our exclusive transportation provider for three years. Their attention to detail, professionalism, and flexibility have made corporate travel seamless for our executives. The dedicated account manager anticipates our needs before we even have to ask.",
  //   isCorporate: false
  // },
  {
    id: 2,
    name: "Balavant Prajapati",
    position: "HR Administrator",
    company: "Akash Enterprises",
    image: "/images/testimonials/sarah-montgomery.jpg",
    rating: 5,
    testimonial: "Coordinating travel for our C-suite executives used to be a logistical challenge until we partnered with The United Travel. Their online booking platform is intuitive, the chauffeurs are consummate professionals, and their billing system integrates perfectly with our expense management software.",
    isCorporate: true
  },
  {
    id: 3,
    name: "Rajesh Patel",
    image: "/images/testimonials/michael-chen.jpg",
    rating: 5,
    testimonial: "I booked a luxury sedan for my wedding and the experience was outstanding! The vehicle was spotless, the driver was very professional and courteous. They arrived on time and made sure everything went smoothly. Highly recommended for any special occasion!"
  },
  {
    id: 4,
    name: "Priya Sharma",
    image: "/images/testimonials/rebecca-williams.jpg",
    rating: 5,
    testimonial: "Used their service for airport transfer and was very impressed. The booking process was simple, the driver was waiting at the airport with a name board, and the ride was comfortable. Great value for money and excellent customer service!"
  },
  {
    id: 5,
    name: "Amit Kumar",
    image: "/images/testimonials/michael-chen.jpg",
    rating: 5,
    testimonial: "Booked an SUV for a family trip and it was perfect! The vehicle was spacious, clean, and well-maintained. The driver was skilled and knew all the routes. Will definitely use their service again for our next family outing."
  },
  // {
  //   id: 6,
  //   name: "Michael Chen",
  //   position: "Director of Operations",
  //   company: "TechForward Solutions",
  //   image: "/images/testimonials/michael-chen.jpg",
  //   rating: 5,
  //   testimonial: "When we host international clients, the transportation experience matters. The United Travel delivers consistently exceptional service that reflects our company standards. From airport pickups to multi-city road shows, they handle everything with precision and class.",
  //   isCorporate: true
  // },
  {
    id: 7,
    name: "Rajiv Kumar",
    position: "Events Manager",
    company: "Endless Events",
    image: "/images/testimonials/rebecca-williams.jpg",
    rating: 5,
    testimonial: "We've relied on The United Travel for our corporate events transportation for years. Their ability to coordinate multiple pickups, complex schedules, and last-minute changes has been invaluable. The vehicles are immaculate, the chauffeurs are professional, and their logistics team is second to none.",
    isCorporate: true
  },
  {
    id: 8,
    name: "Sneha Mehta",
    image: "/images/testimonials/michael-chen.jpg",
    rating: 4,
    testimonial: "Great experience booking a cab for office commute. The app is user-friendly, prices are reasonable, and the service is reliable. The drivers are professional and the vehicles are always clean and well-maintained."
  }
];

